module.exports = __webpack_public_path__ + "static/media/yellow-location-icon.dcce62cc.svg";